import React from "react";
import { BounceLoader } from "react-spinners";

const Loading = () => {
  return (
    <>
      <div
        className='position-absolute top-0 start-0 end-0 bottom d-flex justify-content-center align-items-center transparent-primary '
        style={{ height: "100%" }}
      >
        <div className='mx-auto'>
          <BounceLoader
            color='#090b8f'
            loading={true}
            size={50}
            aria-label='Loading Spinner'
            data-testid='loader'
            className='ms-3'
          />
          <span className='fw-bolder text-primary-1 ms-2'>Please wait...</span>
        </div>
      </div>
    </>
  );
};

export default Loading;
